import React from 'react';

import FtuxComponent from '../../../../common-components/FtuxComponent/FtuxComponent';

import '../../styles/campaign-detail.scss';

const NoContent = ({ requests }) => {
  return (
    <div className="vh-100">
      <FtuxComponent
        height={500}
        icon={requests ? '🤳' : '📷'}
        iconBgColor="#EEEEEE"
        title={`No ${requests ? 'Requests' : 'Posts'} Available`}
        text={
          requests
            ? 'You can request for usage rights from the content section. They will appear here. '
            : 'There are no results for your filtered criteria. Try removing some filters to see posts.'
        }
      />
    </div>
  );
};

export default NoContent;
